import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';
import { Request } from '../../models/Request/request.model';
import { _ } from '@biesbjerg/ngx-translate-extract/dist/utils/utils';
import { EmitType } from '@syncfusion/ej2-base';
import { SelectEventArgs } from '@syncfusion/ej2-navigations';
import { SidebarService } from '../../sidebar/sidebar.service';
import { Util } from '../../helpers/global.util';
import { TranslateService } from '@ngx-translate/core';
import { DataManager } from '@syncfusion/ej2-data';
import { UrlParams } from '../../helpers/url-params';
import { ChangeEventArgs, FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';



@Component({
    selector: 'request-prop',
    templateUrl: './request-prop.html',
    styleUrls: ['./detail-tab/detail-tab.css'],
})
export class RequestPropComponent implements OnInit {
    @ViewChild('tab') tab: any;
    @ViewChild('tabDetail') tabDetail: any;
    @ViewChild('tabDetailHS') tabDetailHS: any;
    @ViewChild('tabInformations') tabInformations: any;    

    subs: any = null;
    id: number = 0;
    edit: number = 0;
    requestCode: string = null;
    informations: any;
    requestStatusId: number = null;
    isViewOtherTab: boolean = false;
    request: Request = new Request();
    iPathCode: number = 0;
    strRequestProp: string = 'Request Properties: ';
    strCountValue: string =''
    filterSearch: string = "";

    dataApply: DataManager;
    requestSrc: string;
    groupUserCode: string = "";
    toggled: boolean = false;
    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute, public sidebar: SidebarService, private router: Router, translate: TranslateService, ) {        
        this.subs = route.params.subscribe(params => {            
            this.id = params['id'];
            this.requestCode = params['requestCode'];            
            this.edit = params['edit'];
            this.iPathCode = params['pathCode'];
            this.requestSrc = params['requestSrc'];
        })

        if (this.edit == 0) { //view mode
            this.isViewOtherTab = true;
        }
        
        this.informations = _('request-prop.Informations');
        this.groupUserCode = this.auth.GroupUserCode;

    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {
        this.groupUserCode = this.auth.GroupUserCode;

        this.sidebar.toggled$.subscribe(val => {
            this.toggled = val;
        });

    }

    ngAfterViewInit() {
        this.load(this.id);
        
    }

    load(id: number) {


        if (id == 0)
        { //new mode
            this.turnTabs(false);
            if (this.requestSrc == "internal")
            {
                this.tabDetailHS.startInit();

            } else {
                this.tabDetail.startInit();
            }
   
        }
        else
        {

            if (this.requestSrc == "internal")
            {

                this.http.get('api/Request/GetByHsOwner/' + id, res => {
                    this.request.set(res.Result);

                    this.tabDetailHS.startInit();

                    this.refresh();
                }, null);

            }
            else
            {
                this.http.get('api/Request/Get/' + id, res => {
                    this.request.set(res.Result);

                    this.tabDetail.startInit();

                    this.refresh();
                }, null);


                
            }




          
        }
    }

    refresh() {
        this.sidebar.getSiteMapByUrlNew(this.auth.GroupUserCode);

        this.requestStatusId = this.request.Idstatus;

        this.sidebar.addPath(this.request.Custname);
        this.sidebar.addPath(this.request.RequestStatusName);
        this.sidebar.addPath(this.request.Requestcode);
        
        this.isViewOtherTab = true;                    

        this.turnTabs(this.isViewOtherTab);
    }

    turnTabs(bShow: boolean) {
        //console.log(bShow);

        setTimeout(() => {
            this.hideTabs(bShow);
        }, 300);
    }

    hideTabs(bShow: boolean) {
        this.tab.hideTab(1, !bShow);
        //this.tab.hideTab(2, !bShow);
        /*this.tab.hideTab(3, !bShow);
        if (this.auth.isZPV) {
            this.tab.hideTab(4, !bShow);
            this.tab.hideTab(5, !bShow);
        } else {
            this.tab.hideTab(4, true);
            this.tab.hideTab(5, true);
        }*/
    }

    onChangedData(evt: any) {

        if (evt.Msg == 'SetEditMode') {
            if (this.edit == 2) {
                //reload page and move to edit mode after create request success
                this.router.navigate(['/request-prop', this.request.ID, this.request.Requestcode, 1, this.requestSrc, 0]);
            }
            else
                this.refresh();
        }
        else if (evt.Msg == 'ChangedDraftSend') {
            //turn on/off tabs
            if (this.edit == 0) { //view mode
                let bShow = true;

                if (evt.DraftSend == 'Draft' && evt.Status == 'Open') {
                    bShow = false;
                }

                this.hideTabs(bShow);
            }
            else if (this.edit == 1) { //edit mode
                let bShow = false;

                if (evt.DraftSend == 'Send') {
                    bShow = true;
                }

                this.hideTabs(bShow);
            }
        }
        else if (evt.Msg == 'CountMessage') {            
            this.strCountValue = 'You have ' + evt.CountValue + ' messages';
            this.refresh();            
        }
    }

    onChangedStatus(status: string) {
        if (this.tabInformations)
            this.tabInformations.setStatus(status);        
    }

    onSelectedTab(evt: SelectEventArgs) {
        if (evt.selectedIndex == 1) {
            this.tabInformations.startInit();
        }        
    }


  
    
}
